// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZTg97","blackText":"styles_blackText__2jZuT","okDisconnect":"styles_okDisconnect__2xsvd"};